import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { getMessageByCode } from "../util/messages";

export default {
  data() {
    return {
      tooltip: {
        textfield: "Wypełnij to pole",
        select: "Wybierz wartość z listy",
        checkbox: "Zaznacz/odznacz opcję",
        scroller: "Przesuń, aby zmienić opcje",
        clearFilter: "Kliknij, aby wyczyścić filtr danych",
        date: "Ustaw parametr raportu",
        uuid: null
      }
    };
  },
  computed: {
    ...mapGetters("auth", ["isLogin"]),
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    }
  },
  beforeCreate() {
    this.uuid = uuidv4();
  },
  methods: {
    labelToId(label = "", sufix, id) {
      const addSufix = sufix !== undefined ? "_" + sufix : "";
      const addId = id !== undefined ? "_v" + id : "";
      const text = label + addSufix + addId;
      return text.replace(/[\s,]/g, "_");
    },
    getMessageMixin(code) {
      return getMessageByCode(code);
    }
  },
  filters: {
    dateDayHour: function(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm") : "-";
    }
  }
};
